import { useEffect, useRef } from 'react';
import { createStore } from '../store/api';
const useQuerySelectorStore = createStore((set, get) => {
  return {
    cache: {},
    retrieve: key => {
      var _get$cache$key;
      return (_get$cache$key = get().cache[key]) !== null && _get$cache$key !== void 0 ? _get$cache$key : null;
    },
    update: (key, selector, query) => {
      set(state => Object.assign({}, state, {
        cache: Object.assign({}, state.cache, {
          [key]: Object.assign({}, query, {
            data: selector(query === null || query === void 0 ? void 0 : query.data)
          })
        })
      }));
    }
  };
});

/**
 * Easily transform and (correctly) cache the data of a query result.
 * @param key - The key to store the query result under. (MUST BE UNIQUE)
 * @param query - The query result to select from.
 * @param selector - The selector function to apply to the query result.
 * @returns A new query result with the selected data. */
export function useQueryStore(key, query, selector) {
  const {
    update,
    retrieve
  } = useQuerySelectorStore();
  const sref = useRef(selector);
  useEffect(() => {
    sref.current = selector;
  });
  useEffect(() => {
    update(key, sref.current, query);
  }, [key, query, query.data, update]);
  return retrieve(key) || query;
}